import styled, { css } from 'styled-components'
import {
  calculateResponsiveSize,
  mediaMax,
  textBoxTrim,
  themeColor
} from '@dboxdev/ui-components'
import {
  CHROME_IN_DELAY,
  CHROME_IN_FADE,
  CHROME_IN_SHIFT,
  SPLASH_EASE_OUT
} from 'styles/splash-timing'
import CloseIcon from 'icons/close.svg'

const CLOSE_ICON = 14
const CLOSE_HIT_PAD = 16

const away = css`
  transform: translateY(${calculateResponsiveSize(CHROME_IN_SHIFT)});
  opacity: 0;
  visibility: hidden;
  transition:
    transform ${CHROME_IN_FADE}s ${SPLASH_EASE_OUT},
    opacity ${CHROME_IN_FADE}s ${SPLASH_EASE_OUT},
    visibility ${CHROME_IN_FADE}s;
`

const settled = css`
  transform: translateY(0);
  opacity: 1;
  visibility: visible;
  transition:
    transform ${CHROME_IN_FADE}s ${SPLASH_EASE_OUT} ${CHROME_IN_DELAY}s,
    opacity ${CHROME_IN_FADE}s ${SPLASH_EASE_OUT} ${CHROME_IN_DELAY}s,
    visibility ${CHROME_IN_FADE}s ${CHROME_IN_DELAY}s;
`

export const Root = styled.div`
  .cookies-banner-accept-btn {
    display: none;
  }
`

export const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  gap: ${calculateResponsiveSize(22)};
  padding: ${calculateResponsiveSize(23)} ${calculateResponsiveSize(30)};
  color: ${themeColor('textColor')};
  background: ${themeColor('accentColor')};
  ${({ $visible }) => ($visible ? settled : away)};
  z-index: 20;
  ${mediaMax('mobile')} {
    gap: ${calculateResponsiveSize(14)};
    padding: ${calculateResponsiveSize(16)} ${calculateResponsiveSize(20)};
    text-align: center;
  }
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  ${mediaMax('mobile')} {
    flex-direction: column;
    align-items: center;
    gap: ${calculateResponsiveSize(14)};
  }
`

export const Disclaimer = styled.p`
  ${textBoxTrim};
  margin: 0;
  width: 100%;
  font-size: ${calculateResponsiveSize(9)};
  line-height: 1.6;
  font-weight: 300;
  text-align: justify;
  text-transform: uppercase;
`

export const Copy = styled.p`
  ${textBoxTrim};
  margin: 0;
  font-size: ${calculateResponsiveSize(18)};
  line-height: 1.4;
  font-weight: 300;
  ${mediaMax('mobile')} {
    width: ${calculateResponsiveSize(268)};
    font-size: ${calculateResponsiveSize(12)};
  }
`

export const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: ${calculateResponsiveSize(142)};
  ${mediaMax('mobile')} {
    justify-content: center;
    gap: 0;
  }
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${calculateResponsiveSize(5)};
  flex-shrink: 0;
`

export const CloseButton = styled.button`
  color: inherit;
  flex-shrink: 0;
  width: ${calculateResponsiveSize(21)};
  height: ${calculateResponsiveSize(21)};
  padding: 0;
  border: 0;
  background-color: currentColor;
  mask: url(${CloseIcon}) no-repeat center / contain;
  -webkit-mask: url(${CloseIcon}) no-repeat center / contain;
  cursor: pointer;
  ${mediaMax('mobile')} {
    position: absolute;
    top: ${calculateResponsiveSize(10 - CLOSE_HIT_PAD)};
    right: ${calculateResponsiveSize(10 - CLOSE_HIT_PAD)};
    width: ${calculateResponsiveSize(CLOSE_ICON + CLOSE_HIT_PAD * 2)};
    height: ${calculateResponsiveSize(CLOSE_ICON + CLOSE_HIT_PAD * 2)};
    mask-size: ${calculateResponsiveSize(CLOSE_ICON)};
    -webkit-mask-size: ${calculateResponsiveSize(CLOSE_ICON)};
  }
`
